"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var resets = hs_web_style_guide_1.css({
  color: colors_1.comet,
  margin: 0,
  padding: 0
});
var labelStyle = hs_web_style_guide_1.css({
  color: colors_1.silverChalice
});

function Display1(props) {
  return React.createElement("h2", __assign({}, resets, font_1.display1, props), props.children);
}

exports.Display1 = Display1;

function TitleL(props) {
  return React.createElement("h2", __assign({}, resets, font_1.titleL, props), props.children);
}

exports.TitleL = TitleL;

function TitleM(props) {
  return React.createElement("h3", __assign({}, resets, font_1.titleM, props), props.children);
}

exports.TitleM = TitleM;

function TitleS(props) {
  return React.createElement("h4", __assign({}, resets, font_1.titleS, props), props.children);
}

exports.TitleS = TitleS;

function TitleXS(props) {
  return React.createElement("h5", __assign({}, resets, font_1.titleXS, props), props.children);
}

exports.TitleXS = TitleXS;

function UIRegularL(props) {
  return React.createElement("div", __assign({}, resets, font_1.uiRegularL, props), props.children);
}

exports.UIRegularL = UIRegularL;

function UIRegularM(props) {
  return React.createElement("div", __assign({}, resets, font_1.uiRegularM, props), props.children);
}

exports.UIRegularM = UIRegularM;

function UIRegularS(props) {
  return React.createElement("div", __assign({}, resets, font_1.uiRegularS, props), props.children);
}

exports.UIRegularS = UIRegularS;

function UIBoldL(props) {
  return React.createElement("div", __assign({}, resets, font_1.uiBoldL, props), props.children);
}

exports.UIBoldL = UIBoldL;

function UIBoldM(props) {
  return React.createElement("div", __assign({}, resets, font_1.uiBoldM, props), props.children);
}

exports.UIBoldM = UIBoldM;

function UIBoldS(props) {
  return React.createElement("div", __assign({}, resets, font_1.uiBoldM, props), props.children);
}

exports.UIBoldS = UIBoldS;

function LabelBoldM(props) {
  return React.createElement("label", __assign({}, resets, font_1.labelBoldM, labelStyle, props), props.children);
}

exports.LabelBoldM = LabelBoldM;

function LabelBoldS(props) {
  return React.createElement("label", __assign({}, resets, font_1.labelBoldS, labelStyle, props), props.children);
}

exports.LabelBoldS = LabelBoldS;

function LabelRegularS(props) {
  return React.createElement("label", __assign({}, resets, font_1.labelRegularS, labelStyle, props), props.children);
}

exports.LabelRegularS = LabelRegularS;